export const subscriptionStatuses = ['NOT_REQUIRED', 'NOT_PAID', 'PAID'] as const;
export type SubscriptionStatus = typeof subscriptionStatuses[number];

export const subscriptionPeriods = ['MONTHLY', 'YEARLY'] as const;
export type SubscriptionPeriod = typeof subscriptionPeriods[number];

export const subscriptionPackages = ['PERFORMANCE', 'RECRUITMENT'] as const;
export type SubscriptionPackage = typeof subscriptionPackages[number];
